import ReactDOM from 'react-dom/client';
import './index.css';
import { Logger } from './engine/core/Logger';
import ProductShell from './product/shell/ProductShell';

// crypto.randomUUID exists only in secure contexts. When the presenter is iframed by a
// non-secure parent (http dev hosts, test harnesses) the whole frame loses secure-context
// status and every `new AppSettingsData()` would crash. Math.random fallback is fine here —
// these IDs are session-local object identities, not security tokens.
if (typeof crypto !== 'undefined' && typeof crypto.randomUUID !== 'function') {
  crypto.randomUUID = () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}

// Enable remote logging EARLY — independent of any UI component mounting.
// Without this, logs were only sent when MobileDebugConsole was alive.
Logger.Instance.enableRemoteLogging().catch(() => {});
// Expose globally so files without an explicit Logger import (e.g. one-off diagnostics) can log.
if (typeof window !== 'undefined') (window)._engineLogger = Logger.Instance;

// Startup heartbeat: every 2s for the first 60s, log a liveness beacon with JS heap.
// When a mobile browser OOM-kills the tab (no JS error fires!), the last heartbeat in the
// log-api pinpoints the time of death and the phase the app was in.
if (typeof window !== 'undefined') {
  let beats = 0;
  const hb = setInterval(() => {
    beats++;
    try {
      const heapMb = performance.memory ? Math.round(performance.memory.usedJSHeapSize / 1e6) : -1;
      Logger.Instance.Info(`heartbeat #${beats} heap=${heapMb}MB pois=${window.engineApp?.getPOICount?.() ?? '?'}`, 'HB');
      Logger.Instance.forceFlush?.();
    } catch {}
    if (beats >= 30) clearInterval(hb);
  }, 2000);
}

// NOTE: deliberately NOT wrapped in React.StrictMode. StrictMode double-invokes every
// effect in dev (mount → cleanup → mount), which for a heavy WebGL engine means double
// Scene/Renderer/Camera construction, double remote-logger sessions and double content
// fetches. The engine is not a throwaway component — one init per page load.
ReactDOM.createRoot(document.getElementById('root')).render(<ProductShell />);
